import * as React from 'react';
import * as _ from 'underscore';

import './carousel.less';

interface P {
    interval?: number;
}

interface S {
    active: number;
}

export default class Carousel extends React.Component<P, S> {

    constructor( props: P, context: S ) {
        super( props, context );

        this.state = { active: 0 };
    }

    componentDidMount() {
        this.start();
    }

    componentWillUnmount() {
        this.stop();
    }

    private interval_: number;

    private start() {
        this.interval_ = setInterval(
            () => this.setState({
                active: ( this.state.active + 1 ) % React.Children.count( this.props.children )
            }),
            this.props.interval || 3500
        );
    }

    private stop() {
        if ( this.interval_ ) {
            clearInterval( this.interval_ );

            this.interval_ = null;
        }
    }

    render() {
        return (
            <div className="carousel component"
                 onMouseOver={ () => this.stop() }
                 onMouseOut={ () => this.start() }>
              { React.Children.map(this.props.children, (g, i) => {
                    const { props } = g as React.ReactElement<any>;

                    return <img { ... _.defaults({
                            className: _.compact([ i == this.state.active && 'active',
                                                   props.className ]).join(' ')
                        }, props) } />;
                }) }
              <ul className="indicators">
                { React.Children.map(this.props.children, (g, i) =>
                    <li className={ i == this.state.active && 'active' || '' }
                        key={ i } />) }
              </ul>
            </div>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./src/components/widgets/Carousel.tsx
 **/